var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3HeatingMgt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.71 56l8.61 10H20l-8.77-10.26 10.07-9.81-10.07-9.82L19.92 26h5.27l-8.48 9.87L27 45.93 16.71 56zM32 12H18v4h14v-4zm17 9h4v-5h5v-4h-5V7h-4v5h-5v4h5v5zm15.77 24.93L54.44 35.87 62.92 26h-5.27L49 36.11l10 9.82-10 9.81L57.78 66h5.27l-8.61-10 10.33-10.07zm-12.58 0L41.87 35.87 50.34 26h-5.27l-8.69 10.11 10.08 9.81-10.08 9.82L45.2 66h5.27l-8.6-10 10.32-10.07zm-12.58 0L29.29 35.87 37.77 26h-5.28L23.8 36.11l10.08 9.81-10.08 9.82L32.62 66h5.28l-8.61-10 10.32-10.07z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Heating_mgt.0380c4c2.svg";
export { SvgB3HeatingMgt as ReactComponent };